<template>
  <div class="bg-white relative border rounded-lg">
    <slot></slot>
  </div>
</template>
